export const FREE_SLOT_LABEL = 'Open for meetings';

/** Soft sky tone for free-availability blocks on the calendar grid. */
export const FREE_SLOT_COLOR = '#bae6fd';

const LEGACY_FREE_SLOT_NOTES = new Set(['Candidate-defined free slot', 'Free Availability']);

export function formatFreeSlotLabel(notes?: string | null): string {
  const trimmed = notes?.trim();
  if (!trimmed || LEGACY_FREE_SLOT_NOTES.has(trimmed)) {
    return FREE_SLOT_LABEL;
  }
  return trimmed;
}

export interface CalendarBusyBlock {
  id: string;
  start: string;
  end: string;
  source?: string;
  title?: string | null;
  blocksAvailability?: boolean;
}

/** Two ranges overlap if startA < endB && endA > startB */
export function rangesOverlap(aStart: Date, aEnd: Date, bStart: Date, bEnd: Date): boolean {
  return aStart.getTime() < bEnd.getTime() && aEnd.getTime() > bStart.getTime();
}

export function getBlockingBusySlots(slots: CalendarBusyBlock[]): CalendarBusyBlock[] {
  return slots.filter(
    (s) =>
      s.blocksAvailability !== false &&
      (s.source === 'integration' || s.source === 'manual' || s.source === 'meeting')
  );
}

export function isSlotBlockedByBusy(
  slotStart: Date,
  slotEnd: Date,
  busySlots: CalendarBusyBlock[]
): CalendarBusyBlock | null {
  const blocking = getBlockingBusySlots(busySlots);
  return (
    blocking.find((busy) => {
      const bStart = new Date(busy.start);
      const bEnd = new Date(busy.end);
      return rangesOverlap(slotStart, slotEnd, bStart, bEnd);
    }) ?? null
  );
}

export function daysWithBusyEvents(busySlots: CalendarBusyBlock[], days: Date[]): Set<string> {
  const keys = new Set<string>();
  const blocking = getBlockingBusySlots(busySlots);

  for (const day of days) {
    const dayKey = day.toISOString().slice(0, 10);
    const dayStart = new Date(day);
    dayStart.setHours(0, 0, 0, 0);
    const dayEnd = new Date(day);
    dayEnd.setHours(23, 59, 59, 999);

    const hasBusy = blocking.some((busy) => {
      const bStart = new Date(busy.start);
      const bEnd = new Date(busy.end);
      return rangesOverlap(dayStart, dayEnd, bStart, bEnd);
    });

    if (hasBusy) keys.add(dayKey);
  }

  return keys;
}
